import React from 'react'
import arrowDown from '../../assets/icons/common/arrowDown.svg'
import profileImage from '../../assets/images/profileImage.png';
const HeaderUser = () => {
  return (
    <div className='flex items-center '>
        <img src={profileImage} alt=''/>
        <h3 className='pl-[6px]'>Tarık Subaşı</h3>
        <span className='pl-[8px]'>
        <img src={arrowDown} alt=''/>
        </span>
    </div>
  )
}

export default HeaderUser